import './css/Style.css';
function Responsivo({ body }) {
    return <>
        <section className='container_responsivo_fundo'></section>
        <section className='container_responsivo' id={'container_responsivo'}>
            {body}
        </section>
    </>
}
export {
    Responsivo
}